import React from 'react'
import styled from 'styled-components'
import { media } from '../../../styles/utils'
import { lightGrey } from '../../../styles/colors'

const OpenPositionsWrapper = styled.section`
  display: flex;
  align-items: flex-start;
  gap: 4rem;
  padding: 2rem 0;

  ${media.phone`
    flex-direction: column;
    gap: 2rem;
  `}
`

const ImageContainer = styled.div`
  flex: 1;
  max-width: 400px;

  img {
    width: 100%;
    height: auto;
    display: block;
  }
`

const ContentContainer = styled.div`
  flex: 2;
  display: flex;
  flex-direction: column;
`

const Title = styled.h2`
  font-size: 36px;
  line-height: 1.21;
  margin-bottom: 1.5rem;

  ${media.phone`
    font-size: 32px;
  `}
`

const Description = styled.p`
  margin-bottom: 2rem;
  font-size: 18px;
  color: ${lightGrey};
`

const JobList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0 0 2rem 0;
  width: 100%;
`

const JobItem = styled.li`
  border-bottom: 1px solid #e0e0e0;

  a {
    color: inherit;
    text-decoration: none;
    display: block;
    padding: 1.5rem 0;
    font-size: 18px;
    transition: color 0.2s ease-in-out;

    &:hover {
      color: black;
    }
  }
`

const ViewAllLink = styled.a`
  font-size: 24px;
  line-height: 1.21;
  letter-spacing: 0.09px;
  color: black;
  text-decoration: underline;

  ${media.phone`
    font-size: 18px;
  `}
`

const BlockOpenPositions = ({
  title,
  description,
  image,
  jobs,
  view_all_link,
}) => {
  return (
    <OpenPositionsWrapper>
      {image && (
        <ImageContainer>
          <img src={image.url} alt={image.alt || title} />
        </ImageContainer>
      )}
      <ContentContainer>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
        {Array.isArray(jobs) && jobs.length > 0 && (
          <JobList>
            {jobs.map((job, index) => (
              <JobItem key={index}>
                <a href={job.url} target="_blank" rel="noopener noreferrer">
                  {job.job_title}
                </a>
              </JobItem>
            ))}
          </JobList>
        )}
        {view_all_link && view_all_link.url && (
          <ViewAllLink href={view_all_link.url} target="_blank" rel="noopener noreferrer">
            {view_all_link.title}
          </ViewAllLink>
        )}
      </ContentContainer>
    </OpenPositionsWrapper>
  )
}

export default BlockOpenPositions
